import dayjs from "dayjs";
import { Member } from "../../../dao/Member";
import { SpwkUtil } from "../../../dao/SpwkUtil";
import { UniOption } from "../../../dao/UniOption";
import { UniQuestion } from "../../../dao/UniQuestion";
import { new_ErrorAlert } from "../../../export_spwk/ExportManager";
import { HisUiDto, HisRowDto } from "../../../export_spwk/HisDtoManager/HisDto";
import { SpwkMetaData } from "../../../export_spwk/SpwkMetaData";
import { SpwkToHisInfo } from "../SpwkToHisInfo";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import { breadcrumbsClasses } from "@mui/material";

export class HisExcelDto {
  作業編號?: string = "";
  部門: string = "";
  工號: string = "";
  姓名: string = "";
  身分證: string = "";
  既往病史?: string = "";
  是否吸菸?: string = "";
  是否嚼食檳榔?: string = "";
  是否喝酒?: string = "";
  每日平均睡眠時間?: string = "";
  自覺症狀?: string = "";
  糖尿病: string = "";
  吸菸?: string = "";
  曾經從事?: string;
  曾經從事開始日?: string;
  曾經從事結束日?: string;
  目前從事?: string;
  目前從事開始日?: string;
  目前從事結束日?: string;
  Shift?: string = "";
  AverageWorkHoursInPastMonth?: string = "";
  AverageWorkHoursInPastSixMonth?: string = "";
}

const UcUiManager = () => {
  function fillValue(
    member: Member | undefined,
    excelList: HisExcelDto[],
    info: SpwkToHisInfo
  ) {
    let FormList: string[] = [];
    const diabetesList: string[] = [];
    if (member === undefined) {
      throw new_ErrorAlert("9978768 member不該為空");
    } else if (member !== undefined) {
      FormList = member.spwk_uni_func_guids
        .split("﹋")
        .map((id) => id.replace("_", ""));
    }
    for (let i = 0; i < FormList.length; i++) {
      const excel: HisExcelDto = new HisExcelDto();
      if (info.Ans.xls_ui_done_status === "O") {
        excel.作業編號 = FormList[i];
        excel.部門 = member.department;
        excel.工號 = member.employee_id;
        excel.姓名 = member.member_name;
        excel.身分證 = member.sid;
        excel.曾經從事 = info.Ans.ui_prev_work;
        excel.曾經從事結束日 = info.Ans.ui_prev_work_end;
        excel.曾經從事開始日 = info.Ans.ui_prev_work_start;
        excel.曾經從事 = spacetoNull(info.Ans.ui_prev_work);
        excel.曾經從事結束日 = spacetoNull(info.Ans.ui_prev_work_end);
        excel.曾經從事開始日 = spacetoNull(info.Ans.ui_prev_work_start);
        excel.目前從事 = info.Ans.ui_curr_work;
        excel.目前從事結束日 =
          member.rec_dt !== "2999-01-01 00:00:00"
            ? dayjs("" + member.rec_dt).format("YYYY/MM/DD")
            : info.Ans.ui_curr_work_end;
        excel.目前從事開始日 = info.Ans.ui_curr_work_start;
        excel.是否吸菸 = "";
        excel.是否嚼食檳榔 = "";
        excel.是否喝酒 = "";
        excel.每日平均睡眠時間 = info?.HisDto?.問卷基礎[0].平均睡眠時間;
        let shift = info?.HisDto?.問卷基礎[i].是否輪班;
        switch (info?.HisDto?.問卷基礎[i].輪班幾班制) {
          case "2":
            shift += "(兩班制)";
            break;
          case "3":
            shift += "(三班制)";
            break;
          case "4":
            shift += "(四班制)";
            break;
          case "o":
            shift += `(${info.HisDto.問卷基礎[i].輪班幾班制_其他})`;
            break;
          default:
            break;
        }
        excel.Shift = shift || "";
        excel.AverageWorkHoursInPastMonth =
          info?.HisDto?.問卷基礎[i].一個月平均工時 || "";
        excel.AverageWorkHoursInPastSixMonth =
          info?.HisDto?.問卷基礎[i].六個月平均工時 || "";
        if (excel.作業編號 === "A01") {
          excel.既往病史 = xlsImportChangeChinese(info.Ans.ui_a01_ch04);
          if (excel.既往病史 === undefined) {
            info.HisDto_ErrorList.push("既往病史為undefined");
          }
          excel.自覺症狀 = xlsImportChangeChinese(info.Ans.ui_a01_ch06);
        } else if (excel.作業編號 === "B02") {
          excel.既往病史 = xlsImportChangeChinese(info.Ans.ui_b02_ch04);
          excel.自覺症狀 = xlsImportChangeChinese(info.Ans.ui_b02_ch06);
        } else {
          excel.既往病史 = xlsImportChangeChinese(info.Ans.ui_bxx_ch04);
          excel.自覺症狀 = xlsImportChangeChinese(info.Ans.ui_bxx_ch06);
        }
        excel.糖尿病 = Isdiabetes(excel.既往病史, excel.作業編號, info);
        excel.吸菸 = "";
        diabetesList.push(excel.糖尿病);
      } else {
        if (info?.HisDto?.問卷明細 != null) {
          if (member != null) {
            let _pastdiseaseList: HisRowDto[];
            let _IsSmoke: HisRowDto[];
            let _IsBetelNut: HisRowDto[];
            let _IsDrinkWine: HisRowDto[];
            let _symptomsList: HisRowDto[];
            if (FormList[i] === SpwkUtil.CODE_A98) {
              _pastdiseaseList = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "3" && x.項目 === "1" && x.作業編號 === FormList[i]
              );
              _IsSmoke = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "4" && x.項目 === "1" && x.作業編號 === FormList[i]
              );
              _IsBetelNut = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "4" && x.項目 === "2" && x.作業編號 === FormList[i]
              );
              _IsDrinkWine = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "4" && x.項目 === "3" && x.作業編號 === FormList[i]
              );
              _symptomsList = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "5" && x.項目 === "1" && x.作業編號 === FormList[i]
              );
            } else {
              _pastdiseaseList = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "4" && x.項目 === "1" && x.作業編號 === FormList[i]
              );
              _IsSmoke = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "5" && x.項目 === "1" && x.作業編號 === FormList[i]
              );
              _IsBetelNut = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "5" && x.項目 === "2" && x.作業編號 === FormList[i]
              );
              _IsDrinkWine = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "5" && x.項目 === "3" && x.作業編號 === FormList[i]
              );
              _symptomsList = info.HisDto.問卷明細.filter(
                (x) =>
                  x.類別 === "6" && x.項目 === "1" && x.作業編號 === FormList[i]
              );
            }
            excel.作業編號 = FormList[i];
            excel.部門 = member.department;
            excel.工號 = member.employee_id;
            excel.姓名 = info?.HisDto?.姓名;
            excel.身分證 = info?.HisDto?.身份證號;
            excel.曾經從事 = spacetoNull(info.HisDto.問卷基礎[i].曾經從事);
            let shift = info.HisDto.問卷基礎[i].是否輪班;
            switch (info.HisDto.問卷基礎[i].輪班幾班制) {
              case "2":
                shift += "(兩班制)";
                break;
              case "3":
                shift += "(三班制)";
                break;
              case "4":
                shift += "(四班制)";
                break;
              case "o":
                shift += `(${info.HisDto.問卷基礎[i].輪班幾班制_其他})`;
                break;
              default:
                break;
            }
            excel.Shift = shift;
            excel.AverageWorkHoursInPastMonth =
              info.HisDto.問卷基礎[i].一個月平均工時;
            excel.AverageWorkHoursInPastSixMonth =
              info.HisDto.問卷基礎[i].六個月平均工時;
            excel.曾經從事結束日 = spacetoNull(
              info.HisDto.問卷基礎[i].曾經從事結束日
            );
            excel.曾經從事開始日 = spacetoNull(
              info.HisDto.問卷基礎[i].曾經從事開始日
            );
            if (excel.作業編號 === "A98") {
              excel.目前從事 = info.HisDto.問卷基礎[i].目前從事;
              excel.目前從事開始日 = A98Currtime(
                info.HisDto.問卷基礎[i].目前從事開始月
              );
            } else {
              excel.目前從事 = info.HisDto.問卷基礎[i].目前從事;
              excel.目前從事開始日 = info.HisDto.問卷基礎[i].目前從事開始日;
            }
            excel.目前從事結束日 = dayjs("" + member.rec_dt).format(
              "YYYY/MM/DD"
            );
            excel.是否吸菸 =
              FormList[i] !== "A98"
                ? LifeHabbit(_IsSmoke[0], info, "生活習慣")
                : "";
            excel.是否嚼食檳榔 =
              FormList[i] !== "A98"
                ? LifeHabbit(_IsBetelNut[0], info, "生活習慣")
                : "";
            excel.是否喝酒 =
              FormList[i] !== "A98"
                ? LifeHabbit(_IsDrinkWine[0], info, "生活習慣")
                : "";
            excel.每日平均睡眠時間 = info?.HisDto?.問卷基礎[0].平均睡眠時間;
            if (
              (info.Ans.m04 === "" && FormList[i] !== "B02") ||
              (info.Ans.m06 === "" && FormList[i] !== "B02")
            ) {
              alert("此使用者問卷未填寫完");
            } else {
              excel.既往病史 = HisChangeChinese(
                _pastdiseaseList[0],
                info?.ExportBundle?.AllMetaDataList,
                "既往病史"
              );
              excel.自覺症狀 = HisChangeChinese(
                _symptomsList[0],
                info?.ExportBundle?.AllMetaDataList,
                "自覺症狀"
              );
              excel.既往病史 = diseaseCTP(excel.既往病史);
              excel.自覺症狀 = diseaseCTP(excel.自覺症狀);
            }
            excel.糖尿病 = Isdiabetes(excel.既往病史, excel.作業編號, info);
            excel.吸菸 =
              FormList[i] !== "A98"
                ? IsSmoke(excel.是否吸菸, excel.作業編號, _IsSmoke[0])
                : "";
            diabetesList.push(excel.糖尿病);
          }
        } else {
          throw new_ErrorAlert(`7477418 問卷明細檔為空`);
        }
      }
      excelList.push(excel);
      diabetesList.push(excel.糖尿病);
    }
    const diabetesValue = diabetesList.includes("有")
      ? "有"
      : diabetesList.includes("無")
      ? "無"
      : "無需填答";
    for (const excel of excelList) {
      if (
        excel.姓名 === info?.HisDto?.姓名 &&
        excel.身分證 === info?.HisDto?.身份證號
      ) {
        excel.糖尿病 = diabetesValue;
      }
    }
    return excelList;
  }

  function getUiInfo(
    excelList: HisExcelDto[],
    memberList: Member[],
    info: SpwkToHisInfo
  ) {
    if (excelList.length === 0) {
      throw new_ErrorAlert("4793115 不該沒有excelList");
    }

    const updatedUiList: HisUiDto[] = []; // 深層複製 UiList
    for (const member of memberList) {
      if (info.Ans.xls_ui_done_status === "O") {
        const uiData = xlsfillUiValue({}, excelList, member);
        updatedUiList.push(uiData);
      } else {
        const uiData = fillUiValue({}, excelList, member);
        updatedUiList.push(uiData);
      }
    }

    return updatedUiList;
  }
  function spacetoNull(str: string | undefined) {
    if (str !== undefined) {
      if (str === "") {
        str = "無";
        return str;
      } else {
        return str;
      }
    } else {
      return undefined;
    }
  }
  function fillUiValue(Ui: HisUiDto, excelList: HisExcelDto[], member: Member) {
    let find_meta = excelList.filter((x) => x.工號 === member.employee_id);
    let A01 = find_meta.find((x) => x.作業編號 === "A01");
    let B02 = find_meta.find((x) => x.作業編號 === "B02");
    let BXX = find_meta.find(
      (x) => x.作業編號 !== "B02" && x.作業編號 !== "A01"
    );
    let A98: boolean = false;
    if (find_meta.find((x) => x.作業編號 === "A98")) {
      A98 = true;
    }
    type DiseaseResult = {
      disease1: string;
      disease2: string;
    };
    let re: DiseaseResult = { disease1: "", disease2: "" };
    //#region 有A01
    if (A01) {
      if (find_meta.length === 0) {
        throw new_ErrorAlert("4618349 ExcelList不該空");
      }
      //#region 多張問卷
      else if (find_meta.length !== 1) {
        //#region 有B02的既往病史判斷
        if (B02) {
          if (A01.既往病史 && B02.既往病史) {
            if (B02.既往病史 === "無") {
              let str = A01.既往病史;
              re = disease(str, member);
            } else if (A01.既往病史 === "無") {
              let str = B02.既往病史;
              re = disease(str, member);
            } else {
              let str = `${A01.既往病史}、${B02.既往病史}`;
              re = disease(str, member);
            }
          }
        }
        //#endregion
        //沒有B02直接帶A01的進去拆就好
        else if (A01.既往病史) {
          re = disease(A01.既往病史, member);
        }
        Ui.曾經從事 = A01?.曾經從事 === "" ? "無" : A01?.曾經從事;
        Ui.曾經從事開始日 = A01?.曾經從事開始日;
        Ui.曾經從事結束日 = A01?.曾經從事結束日;
        Ui.目前從事 = A01?.目前從事;
        Ui.目前從事開始日 = A01?.目前從事開始日;
        Ui.目前從事結束日 = A01?.目前從事結束日;
        Ui.既往病歷1 = re.disease1;
        Ui.既往病歷2 = re.disease2;
        Ui.作業經歷 = A01?.曾經從事 ? A01?.曾經從事 : "無";
        Ui.自覺症狀 = A01?.自覺症狀 ? A01.自覺症狀 : "無";
        Ui.既往病歷 = A01?.既往病史 ? A01.既往病史 : "無";
        if (A98) {
          Ui.ICD10 = heartdisease(re);
        } else {
          Ui.ICD10 = "";
        }
      } //#endregion
      //單張
      else {
        Ui.曾經從事 = "";
        Ui.曾經從事開始日 = "";
        Ui.曾經從事結束日 = "";
        Ui.目前從事 = "";
        Ui.目前從事開始日 = "";
        Ui.目前從事結束日 = "";
        Ui.既往病歷1 = "";
        Ui.既往病歷2 = "";
        if (A01.既往病史) {
          re = disease(A01.既往病史, member);
        }
        if (A98) {
          Ui.ICD10 = heartdisease(re);
        } else {
          Ui.ICD10 = "";
        }
        Ui.作業經歷 = A01?.曾經從事 ? A01?.曾經從事 : "無";
        Ui.自覺症狀 = A01?.自覺症狀 ? A01.自覺症狀 : "無";
        Ui.既往病歷 = A01?.既往病史 ? A01.既往病史 : "無";
      }
    }
    //#endregion
    //沒有A01
    else {
      if (find_meta.length === 0) {
        throw new_ErrorAlert("9438164 ExcelList不該空");
      }
      //#region 複數問卷
      else if (find_meta.length !== 1) {
        if (B02 && BXX) {
          if (BXX.既往病史 && B02.既往病史) {
            if (B02.既往病史 === "無") {
              let str = BXX.既往病史;
              re = disease(str, member);
            } else if (BXX.既往病史 === "無") {
              let str = B02.既往病史;
              re = disease(str, member);
            } else {
              let str = `${BXX.既往病史}、${B02.既往病史}`;
              re = disease(str, member);
            }
          }
        } else if (BXX) {
          if (BXX.既往病史) {
            re = disease(BXX.既往病史, member);
          }
        } else {
          throw new_ErrorAlert("7946821 B02不該有複數問卷");
        }
      }
      //#endregion
      //#region 單張
      else {
        if (BXX) {
          if (BXX.既往病史) {
            re = disease(BXX.既往病史, member);
          }
        } else if (B02) {
          if (B02.既往病史) {
            re = disease(B02.既往病史, member);
          }
        }
      }
      //#endregion
      let form = find_meta.find((x) => x.作業編號 !== "A01");
      if (form) {
        Ui.曾經從事 = form?.曾經從事 ? form?.曾經從事 : "無";
        Ui.曾經從事開始日 = form?.曾經從事開始日;
        Ui.曾經從事結束日 = form?.曾經從事結束日;
        Ui.目前從事 = form?.目前從事;
        Ui.目前從事開始日 = form?.目前從事開始日;
        Ui.目前從事結束日 = form?.目前從事結束日;
        Ui.既往病歷1 = re.disease1;
        Ui.既往病歷2 = re.disease2;
      }
      if (A98) {
        Ui.ICD10 = heartdisease(re);
      } else {
        Ui.ICD10 = "";
      }
      Ui.作業經歷 = "";
      Ui.自覺症狀 = "";
      Ui.既往病歷 = "";
    }
    if (countChracterlength(Ui.作業經歷) > 150) {
      alert(member.member_name + " 作業經歷字元超過");
    } else if (countChracterlength(Ui.自覺症狀) > 200) {
      alert(member.member_name + " 自覺症狀字元超過");
    } else if (countChracterlength(Ui.既往病歷) > 200) {
      alert(member.member_name + " 既往病歷字元超過");
    }

    return Ui;
  }

  function xlsfillUiValue(
    Ui: HisUiDto,
    excelList: HisExcelDto[],
    member: Member
  ) {
    let find_meta = excelList.filter((x) => x.工號 === member.employee_id);
    let A01 = find_meta.find((x) => x.作業編號 === "A01");
    let B02 = find_meta.find((x) => x.作業編號 === "B02");
    let BXX = find_meta.find(
      (x) => x.作業編號 !== "B02" && x.作業編號 !== "A01"
    );
    let pastDiseaseCombine = "";
    let symptomsCombine = "";
    let A98: boolean = false;
    if (find_meta.find((x) => x.作業編號 === "A98")) {
      A98 = true;
    }
    if (A01?.既往病史 && BXX?.既往病史) {
      pastDiseaseCombine = `${A01.既往病史}、${BXX.既往病史}`;
      pastDiseaseCombine = Repeat(pastDiseaseCombine);
      symptomsCombine = `${A01.自覺症狀}、${BXX.自覺症狀}`;
      symptomsCombine = Repeat(symptomsCombine);
    } else if (A01?.既往病史 && A01.自覺症狀) {
      pastDiseaseCombine = Repeat(A01?.既往病史);
      symptomsCombine = Repeat(A01.自覺症狀);
    } else if (BXX?.既往病史 && BXX.自覺症狀) {
      pastDiseaseCombine = Repeat(BXX?.既往病史);
      symptomsCombine = Repeat(BXX.自覺症狀);
    }
    type DiseaseResult = {
      disease1: string;
      disease2: string;
    };
    let re: DiseaseResult = { disease1: "", disease2: "" };
    if (A01) {
      if (find_meta.length === 0) {
        throw new_ErrorAlert("2483169 ExcelList不該空");
      } else if (find_meta.length !== 1) {
        if (B02?.既往病史) {
          if (B02.既往病史 === "無") {
            re = disease(pastDiseaseCombine, member);
          } else if (pastDiseaseCombine === "無") {
            re = disease(B02.既往病史, member);
          } else {
            let str = `${pastDiseaseCombine}、${B02.既往病史}`;
            re = disease(str, member);
          }
        } else if (A01.既往病史) {
          re = disease(pastDiseaseCombine, member);
        }
        Ui.曾經從事 = A01?.曾經從事 === "" ? "無" : A01?.曾經從事;
        Ui.曾經從事開始日 = A01?.曾經從事開始日;
        Ui.曾經從事結束日 = A01?.曾經從事結束日;
        Ui.目前從事 = A01?.目前從事 === "" ? "無" : A01?.目前從事;
        Ui.目前從事開始日 = A01?.目前從事開始日;
        Ui.目前從事結束日 = A01?.目前從事結束日;
        Ui.既往病歷1 = re.disease1;
        Ui.既往病歷2 = re.disease2;
        Ui.作業經歷 = A01?.曾經從事 ? A01?.曾經從事 : "無";
        Ui.自覺症狀 = symptomsCombine;
        Ui.既往病歷 = pastDiseaseCombine;
        if (A98) {
          Ui.ICD10 = heartdisease(re);
        } else {
          Ui.ICD10 = "";
        }
      } else {
        Ui.曾經從事 = "";
        Ui.曾經從事開始日 = "";
        Ui.曾經從事結束日 = "";
        Ui.目前從事 = "";
        Ui.目前從事開始日 = "";
        Ui.目前從事結束日 = "";
        Ui.既往病歷1 = "";
        Ui.既往病歷2 = "";
        if (A01.既往病史) {
          re = disease(A01.既往病史, member);
        }
        Ui.作業經歷 = A01?.曾經從事 ? A01?.曾經從事 : "無";
        Ui.自覺症狀 = A01?.自覺症狀 ? A01.自覺症狀 : "無";
        Ui.既往病歷 = A01?.既往病史 ? A01.既往病史 : "無";
        if (A98) {
          Ui.ICD10 = heartdisease(re);
        } else {
          Ui.ICD10 = "";
        }
      }
    } else {
      if (find_meta.length === 0) {
        throw new_ErrorAlert("9438651 ExcelList不該空");
      } else if (find_meta.length !== 1) {
        if (B02 && BXX) {
          if (BXX.既往病史 && B02.既往病史) {
            if (B02.既往病史 === "無") {
              let str = BXX.既往病史;
              re = disease(str, member);
            } else if (BXX.既往病史 === "無") {
              let str = B02.既往病史;
              re = disease(str, member);
            } else {
              let str = `${BXX.既往病史}、${B02.既往病史}`;
              re = disease(str, member);
            }
          }
        } else if (BXX) {
          if (BXX.既往病史) {
            re = disease(BXX.既往病史, member);
          }
        } else {
          throw new_ErrorAlert("7946821 B02不該有複數問卷");
        }
      } else {
        if (BXX) {
          if (BXX.既往病史) {
            re = disease(BXX.既往病史, member);
          }
        } else if (B02) {
          if (B02.既往病史) {
            re = disease(B02.既往病史, member);
          }
        }
      }
      let form = find_meta.find((x) => x.作業編號 !== "A01");
      Ui.曾經從事 = form?.曾經從事 ? form?.曾經從事 : "無";
      Ui.曾經從事開始日 = form?.曾經從事開始日;
      Ui.曾經從事結束日 = form?.曾經從事結束日;
      Ui.目前從事 = form?.目前從事 ? form?.目前從事 : "無";
      Ui.目前從事開始日 = form?.目前從事開始日;
      Ui.目前從事結束日 = form?.目前從事結束日;
      Ui.既往病歷1 = re.disease1;
      Ui.既往病歷2 = re.disease2;
      Ui.作業經歷 = "";
      Ui.自覺症狀 = "";
      Ui.既往病歷 = "";
      if (A98) {
        Ui.ICD10 = heartdisease(re);
      } else {
        Ui.ICD10 = "";
      }
    }
    if (countChracterlength(Ui.作業經歷) > 150) {
      alert(member.member_name + " 作業經歷字元超過");
    } else if (countChracterlength(Ui.自覺症狀) > 200) {
      alert(member.member_name + " 自覺症狀字元超過");
    } else if (countChracterlength(Ui.既往病歷) > 200) {
      alert(member.member_name + " 既往病歷字元超過");
    }

    return Ui;
  }

  function HisChangeChinese(
    ans: HisRowDto | undefined,
    meta_list: SpwkMetaData[] | undefined,
    chapter: string
  ): string | undefined {
    let re = [];
    let his_code_list = ans?.結果?.split(",") ?? [];
    if (ans?.作業編號 === SpwkUtil.CODE_B02) {
      if (ans.結果) {
        // console.log(ans?.結果) = "1#2@21#2@22#2@23#2@31#1@32#2@32#6@33#2@34#1@35#2@36#2";
        const items = ans.結果.split("@"); // ['1#2','21#2','22#2','23#2','31#2','32#2','33#2','34#1','35#2','36#2']
        const results: number[] = []; // [2, 2, 2, 2, 2, 2, 2, 1, 2, 2]
        let hiscodes: string[] = []; //['1', '21', '22', '23', '31', '32', '33', '34', '35', '36']
        items.forEach((item) => {
          const values = item.split("#");
          hiscodes.push(values[0]);
          results.push(parseInt(values[1]));
        });
        hiscodes = hiscodes.filter((item, index) => {
          return hiscodes.indexOf(item) === index;
        }); // ['1', '21', '22', '23', '31', '32', '33', '34', '35', '36']
        for (const hiscode of hiscodes) {
          let find_meta = meta_list?.find(
            (x) =>
              x.his_code === hiscode &&
              x.chapter.includes(chapter) &&
              x.func_code === ans.作業編號
          );
          if (
            find_meta?.rhf_value === "有" &&
            find_meta.chapter === "既往病史(噪音作業)"
          ) {
            if (hiscode === "32") {
              const filteredResults = results.filter((x) => x !== 1 && x !== 2);
              if (filteredResults.length === 1) {
                let parts = filteredResults[0];
                const handlers: Record<number, string> = {
                  3: "左耳",
                  4: "右耳",
                  5: "不確定",
                  6: "雙耳",
                };
                re.push("曾有" + handlers[parts] + find_meta.code);
              }
            } else if (hiscode.startsWith("2")) {
              let reString = find_meta.code.replaceAll("？", "");
              re.push("曾經" + reString);
            } else if (hiscode.startsWith("3")) {
              re.push("曾有" + find_meta.code);
            } else if (hiscode === "1") {
              //pass 這題不處理
            } else {
              throw new_ErrorAlert("1976143 + 未知的hiscode");
            }
          }
        }
      }
    } else {
      for (const his_code of his_code_list) {
        let find_meta = meta_list?.find(
          (x) =>
            x.his_code === his_code &&
            x.func_code === ans?.作業編號 &&
            x.chapter === chapter
        );
        let opt = find_meta?.data_obj as UniOption;
        let val = opt?.option_title ?? "???";
        if (opt === null || opt === undefined) {
          throw new_ErrorAlert("4978787 opt為null");
        } else if (opt.Inputs?.length === 1) {
          if (ans?.作業編號 === SpwkUtil.CODE_A98) {
            let input_val = A98find_option_input_val(his_code, ans.備註);
            val = val.replace("{_1_}", ":" + (input_val ?? "______"));
          } else {
            let input_val = find_option_input_val(his_code, ans?.備註);
            val = val.replace("{_1_}", ":" + (input_val ?? "______"));
          }
        }
        re.push(val);
      }
    }
    let result = re.filter((x) => x !== "無").join("、");
    if (result === "以上皆無" || result === "") {
      result = "無";
    }
    return result;
  }

  function find_option_input_val(his_code: string, 備註: string | undefined) {
    備註 = 備註 ?? "";
    let splits = 備註.split("@");

    let find_str = splits.find(
      (x) =>
        x.startsWith("4_" + his_code + "#") ||
        x.startsWith("6_" + his_code + "#")
    );

    find_str = find_str
      ?.replace("4_" + his_code + "#", "")
      .replace("6_" + his_code + "#", "");
    return find_str;
  }
  function A98find_option_input_val(
    his_code: string,
    備註: string | undefined
  ) {
    備註 = 備註 ?? "";
    let splits = 備註.split("@");

    let find_str = splits.find(
      (x) =>
        x.startsWith("3_" + his_code + "#") ||
        x.startsWith("5_" + his_code + "#")
    );

    find_str = find_str
      ?.replace("3_" + his_code + "#", "")
      .replace("5_" + his_code + "#", "");
    return find_str;
  }
  function LifeHabbit(
    ans: HisRowDto,
    info: SpwkToHisInfo,
    chapter: string
  ): string | undefined {
    let find_metalist = info.ExportBundle?.AllMetaDataList.filter(
      (x) =>
        x.chapter === chapter &&
        x.data_type === "題目" &&
        x.his_code === ans.項目 &&
        x.func_code === ans.作業編號
    );
    if (find_metalist === (null || undefined)) {
      throw new_ErrorAlert("4974150 find_meta不為空");
    }
    let re = "";
    let find_meta = find_metalist[0];
    let select = -1;
    let opt = find_meta?.data_obj as UniQuestion;
    if (find_meta.rhf_value === undefined) {
      throw new_ErrorAlert("7415648 請確認該受檢者的答案");
    } else {
      switch (find_meta.rhf_value) {
        case "從未":
          select = 0;
          break;
        case "偶爾":
          select = 1;
          break;
        case "每天":
          select = 2;
          break;
        case "已戒":
          select = 3;
          break;
      }
      if (opt.Options != null && opt.Options !== undefined) {
        re = opt.Options[select].option_title;
        if (ans.備註 !== "") {
          let input_val: string = fillTimes(ans, re);
          re = input_val;
        }
      }
    }
    return re;
  }

  function fillTimes(ans: HisRowDto, opt_title: string): string {
    if (ans.備註 != null) {
      let ori = opt_title;
      let val = ans.備註.split("#")[1].split("@");
      let re = ori
        .replace("{_1_}", val[0])
        .replace("{_2_}", val[1])
        .replace("{_3_}", val[2]);
      return re;
    }
    return opt_title;
  }

  function Isdiabetes(
    disease: string | undefined,
    func_code: string,
    info: SpwkToHisInfo
  ) {
    if (func_code === "B02") {
      return "B02 請參考其他張特做";
    }
    if (func_code === "A01") {
      if (disease !== undefined) {
        if (disease.includes("糖尿病")) {
          return "有";
        } else if (disease.includes("糖尿病") === false) {
          return "無";
        } else {
          throw new_ErrorAlert("3261354 不知名的意外");
        }
      }
    } else {
      let finds = info.ExportBundle?.AllMetaDataList.filter(
        (x) =>
          x.func_code === func_code &&
          x.chapter === "既往病史" &&
          x.code === "糖尿病"
      );
      if (finds?.length !== 0) {
        if (disease?.includes("糖尿病")) {
          return "有";
        } else {
          return "無";
        }
      }
      return "";
    }
    throw new_ErrorAlert("7913465 不知名的意外");
  }

  function IsSmoke(
    smoke: string | undefined,
    func_code: string,
    ans: HisRowDto
  ) {
    if (ans.結果 === "2" || ans.結果 === "3") {
      return "有";
    } else if (ans.結果 === "4") {
      const regex = /(\d+)年/;
      if (smoke === null || smoke === undefined) {
        throw new_ErrorAlert("4477991 smoke為空");
      }
      const matches = smoke.match(regex);
      if (matches && matches.length > 1) {
        const years = parseInt(matches[1]);
        if (years >= 1) {
          return "無";
        } else {
          return "有";
        }
      }
    } else if (ans.結果 === "1") {
      return "無";
    } else {
      throw new_ErrorAlert("0486231 請確認此受檢者的答案");
    }
  }

  function disease(input: string, member: Member) {
    let characterlength = 0;
    let lastCommaIndex = -1; // 最後一個「、」的索引值
    let disease1: string = "";
    let disease2: string = "";
    let str = input;
    for (let i = 0; i < str.length; i++) {
      let charCode = str.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128) {
        characterlength++;
      } else {
        characterlength += 2;
      }
      if (str[i] === "、") {
        lastCommaIndex = i;
      }
      if (characterlength > 100) {
        if (lastCommaIndex !== -1 && lastCommaIndex <= 100) {
          disease1 = str.substring(0, lastCommaIndex);
          disease2 = str.substring(lastCommaIndex + 1);
          let dis1Count = countChracterlength(disease1);
          let dis2Count = countChracterlength(disease2);
          if (dis1Count + dis2Count > 200) {
            alert(`${member.member_name} 既往病歷1+2超過 200 個字元`);
          } else if (dis2Count > 100) {
            alert(`${member.member_name} 既往病歷2超過 100 個字元`);
          }
        }
        break; // 因為已經找到超過100的字串，所以可以中斷迴圈
      }
    }
    if (characterlength <= 100) {
      disease1 = str;
      disease2 = "無";
    }

    return { disease1, disease2 };
  }

  function diseaseCTP(str: string | undefined) {
    //冒號轉括號
    if (str) {
      let re = str
        .split("、")
        .map((item) => {
          const [key, value = ""] = item.split(":");
          return `${key}${value ? `(${value})` : ""}`;
        })
        .join("、");
      return re;
    }
    return "";
  }
  function Repeat(str: string) {
    let arr = str.split("、");
    let uniqueArr = arr.filter((item, index) => arr.indexOf(item) === index);
    uniqueArr = uniqueArr.filter((x) => x !== "無");
    str = uniqueArr.join("、");
    if (str === "") {
      return "無";
    }
    return str;
  }
  function countChracterlength(input: string) {
    let characterlength = 0; //字元
    if (input !== undefined) {
      for (let i = 0; i < input.length; i++) {
        let charCode = input.charCodeAt(i); //將每個字拆開
        //#region 將不是英文或數字的+2
        if (charCode >= 0 && charCode <= 128) {
          characterlength++;
        } else {
          characterlength += 2;
        }
        //#endregion
      }
    }
    return characterlength;
  }
  function xlsImportChangeChinese(str: string): string {
    const regex = /﹋/g;
    const result = str.replace(regex, "、");
    if (result === "") {
      return "無";
    }
    return result;
  }

  return {
    fillValue, // 將 fillValue 函式匯出
    fillUiValue,
    getUiInfo,
  };
};

export default UcUiManager;

function A98Currtime(A98time: string | undefined): string {
  if (A98time !== undefined) {
    let year = A98time.substring(0, 3);
    let y = parseInt(year) + 1911;
    const month = A98time.substring(3);
    return `${y}/${month}`;
  }
  return "";
}
function heartdisease(re: { disease1: string; disease2: string }): string {
  let disease = re.disease1 + re.disease2;
  let icd10 = "";

  if (disease.includes("心律不整")) {
    icd10 = icd10 + "、I499";
  }
  if (disease.includes("心絞痛")) {
    icd10 = icd10 + "、I208";
  }
  if (disease.includes("心肌梗塞")) {
    icd10 = icd10 + "、I252";
  }
  if (disease.includes("心臟病")) {
    icd10 = icd10 + "、I519";
  }
  icd10 = icd10.replace("、", "");
  return icd10;
}
